import { css } from '@emotion/react'

export const itemWrapper = css`
    display: flex;
    margin: -4px;
`

export const item = css`
    margin: 4px;
`

export const relative = css`
    position: relative;
`

export const border = css`
    border-left: 1px solid #e6e9ed;
`

export const rightPanel = css`
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

export const colors = css`
    overflow: auto;
    flex: 1 1 auto;
`

export const buttons = css`
    flex: 0 0 auto;
    padding: 16px;
    height: 65px;
    border-top: 1px solid #e6e9ed;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
`

export const logo = css`
    border: 1px dashed #ccc;
`
